var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedem(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9993 8.99665C2.79467 8.99665 3.55746 9.31261 4.11988 9.87502C4.68229 10.4374 4.99825 11.2002 4.99825 11.9956C4.99825 12.791 4.68229 13.5538 4.11988 14.1162C3.55746 14.6786 2.79467 14.9945 1.9993 14.9945V16.9938C1.9993 17.5241 2.20994 18.0326 2.58488 18.4076C2.95982 18.7825 3.46835 18.9931 3.9986 18.9931H19.993C20.5232 18.9931 21.0318 18.7825 21.4067 18.4076C21.7817 18.0326 21.9923 17.5241 21.9923 16.9938V14.9945C21.1969 14.9945 20.4341 14.6786 19.8717 14.1162C19.3093 13.5538 18.9933 12.791 18.9933 11.9956C18.9933 11.2002 19.3093 10.4374 19.8717 9.87502C20.4341 9.31261 21.1969 8.99665 21.9923 8.99665V6.99735C21.9923 6.4671 21.7817 5.95857 21.4067 5.58363C21.0318 5.20869 20.5232 4.99805 19.993 4.99805H3.9986C3.46835 4.99805 2.95982 5.20869 2.58488 5.58363C2.20994 5.95857 1.9993 6.4671 1.9993 6.99735V8.99665Z",
    stroke: "white",
    strokeWidth: 1.9993,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9955 4.99805V6.99805",
    stroke: "white",
    strokeWidth: 1.9993,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9955 16.9941V18.9941",
    stroke: "white",
    strokeWidth: 1.9993,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9955 10.9961V12.9961",
    stroke: "white",
    strokeWidth: 1.9993,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedem);
export default __webpack_public_path__ + "static/media/redem.84f42dd07788ca5ec918405c435b5ae5.svg";
export { ForwardRef as ReactComponent };